"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
var react_1 = __importStar(require("react"));
var lodash_1 = require("lodash");
var react_router_dom_1 = require("react-router-dom");
var SearchVacanciesContext_1 = __importDefault(require("../context/SearchVacanciesContext"));
var useShowVacancy_1 = __importDefault(require("../vacancies/useShowVacancy"));
var SearchBarView_1 = __importDefault(require("./SearchBarView"));
var useIsMobileFullScreen_1 = __importDefault(require("../hooks/useIsMobileFullScreen"));
var SearchBarContainer = function () {
    var navigate = (0, react_router_dom_1.useNavigate)();
    var pathname = (0, react_router_dom_1.useLocation)().pathname;
    var instantSearch = pathname.includes('/vacancies');
    var isMobileFullScreen = (0, useIsMobileFullScreen_1.default)();
    var _a = (0, react_1.useContext)(SearchVacanciesContext_1.default), vacancies = _a.vacancies, updateQuery = _a.updateQuery;
    var showVacancy = (0, useShowVacancy_1.default)();
    var handleSearchClick = function () {
        var _a;
        if (!instantSearch) {
            navigate('/vacancies');
            return;
        }
        if (!((_a = vacancies === null || vacancies === void 0 ? void 0 : vacancies.data) === null || _a === void 0 ? void 0 : _a.length)) {
            return;
        }
        showVacancy(vacancies.data[0].id, vacancies.data[0].slug);
    };
    var handleSearchChange = function (e) {
        e.persist();
        debouncedSearchChange(e);
    };
    var debouncedSearchChange = (0, lodash_1.debounce)(function (e) {
        updateQuery({ search: e.target.value });
    }, 300);
    if (isMobileFullScreen) {
        return null;
    }
    return (0, jsx_runtime_1.jsx)(SearchBarView_1.default, { handleSearchChange: handleSearchChange, handleSearchClick: handleSearchClick });
};
exports.default = SearchBarContainer;
